// extracted by mini-css-extract-plugin
module.exports = {"root":"AlbumCell_root__2OGHD","title":"AlbumCell_title__27yRe","coverAnchor":"AlbumCell_coverAnchor__B9pbf"};